import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import { API } from "../lib/api";
import { celebrate } from "../components/bits";

const T = {
  "मराठी": { hi: (n) => `नमस्कार ${n} 🙏`, done: "झालं ✅ Done", thanks: "धन्यवाद 🙏", note: (a) => `${a} यांनी तुम्हाला UnloadIt मध्ये जोडलं. आम्ही फक्त तुमचं पहिलं नाव आणि कामं ठेवतो.`, used: "हे काम आधीच झालं आहे 🙏", bad: "ही लिंक आता चालत नाही." },
  "हिंदी": { hi: (n) => `नमस्ते ${n} 🙏`, done: "हो गया ✅ Done", thanks: "धन्यवाद 🙏", note: (a) => `${a} ने आपको UnloadIt में जोड़ा है। हम सिर्फ़ आपका पहला नाम और काम रखते हैं।`, used: "यह काम पहले ही हो गया है 🙏", bad: "यह लिंक अब काम नहीं करती।" },
  Hinglish: { hi: (n) => `Namaste ${n} 🙏`, done: "Ho gaya ✅ Done", thanks: "Dhanyavaad 🙏", note: (a) => `${a} ne aapko UnloadIt mein joda hai. Hum sirf aapka pehla naam aur kaam rakhte hain.`, used: "Yeh kaam ho chuka hai 🙏", bad: "Yeh link ab kaam nahi karti." },
  English: { hi: (n) => `Hello ${n} 🙏`, done: "Done ✅", thanks: "Thank you 🙏", note: (a) => `${a} added you to UnloadIt. We keep only your first name and tasks.`, used: "This task is already done 🙏", bad: "This link no longer works." },
};
T["िहंदी"] = T["हिंदी"];

export default function Elder() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [done, setDone] = useState(false);
  useEffect(() => { axios.get(`${API}/d/${token}`).then((r) => setInfo(r.data)).catch(() => setInfo({ state: "invalid" })); }, [token]);
  const t = T[info?.language] || T.English;
  const tap = async () => {
    try { await axios.post(`${API}/d/${token}/done`); celebrate(); setDone(true); } catch (e) { setInfo({ ...info, state: "done" }); }
  };
  return (
    <div className="min-h-screen bg-[#FBF9FF] flex justify-center">
      <div className="w-full max-w-[480px] px-6 pt-16 pb-10 flex flex-col items-center text-center" data-testid="elder-page">
        <img src="/icons/icon-192.png" alt="" className="w-16 h-16 rounded-2xl mb-6" />
        {!info ? <p className="ul-shimmer font-display text-2xl">…</p> : done ? (
          <motion.div initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}>
            <div className="text-7xl mb-4">🌸</div>
            <p className="font-display text-4xl font-extrabold" data-testid="elder-thanks">{t.thanks}</p>
          </motion.div>
        ) : info.state === "open" ? (
          <>
            <p className="font-display text-3xl font-bold" data-testid="elder-hi">{t.hi(info.name)}</p>
            <p className="font-display text-[34px] leading-tight font-extrabold mt-6 mb-10" data-testid="elder-task-title">{info.title}</p>
            <button data-testid="elder-done-btn" onClick={tap} className="w-full rounded-3xl text-white font-display text-4xl font-extrabold py-7 shadow-xl active:scale-95 transition-transform" style={{ background: "#1E9E55" }}>{t.done}</button>
          </>
        ) : (
          <p className="font-display text-3xl font-bold" data-testid="elder-state">{info.state === "done" || info.state === "expired" ? t.used : t.bad}</p>
        )}
        {info?.admin_name && <p className="text-sm text-[#6B6680] mt-auto pt-16">{t.note(info.admin_name)} <a href="/legal/privacy" className="underline">Privacy Policy</a></p>}
      </div>
    </div>
  );
}
